/**
 * Retrieves the video data for a given video ID from the video API.
 *
 * @async
 * @param {object} videoApi - The video API object containing the API URL and domain.
 * @param {string} videoID - The ID of the video to retrieve data for.
 * @returns {Promise<object>} - A promise that resolves with the video data object.
 */
export const getVideoData = async (videoApi, videoID) => {
  const { videoApiUrl, domain } = videoApi;
  try {
    const response = await fetch(
      videoApiUrl + `?uuid=${videoID}&domain=${domain}`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error retrieving video data", error);
    return null;
  }
};

export const checkForForceLoad = liveConfigData => {
  return (
    !!liveConfigData?.forceAdditionalProperties?.forceLoadVideo ||
    !!liveConfigData?.forceAdditionalProperties?.youtubeVideoId
  );
};
